import { ListIcon as ChakraListIcon } from '@chakra-ui/react'

import { ListIconProps } from './ListIcon.types'

export default function ListIcon(props: ListIconProps) {
  return <ChakraListIcon {...props} />
}
